// Startseite Hero-Slideshow (sections/home-hero.liquid).
// Figma-Kommentar (Alex Wastl, 25.08.): der Strich zeigt, wie lange die Slide noch sichtbar ist, Dauer 7 s.
// Nutzerentscheidung 2026-09-19 (David): die Slideshow laeuft unter der Maus WEITER. Die urspruengliche
// Pause bei Hover war meine Zutat, nicht aus dem Figma, und fiel im Review als stoerend auf.
// Barrierefreiheit (WCAG 2.2.2): Pause bleibt bei Tastaturfokus im Hero und bei unsichtbarem Tab;
// prefers-reduced-motion: reduce -> kein Autoplay. Indikatoren sind Knoepfe (jederzeit anklickbar).
// Zeitmessung ueber Date.now(): Fortschritt = aufsummierte Zeit, in der nicht pausiert ist.
(() => {
  const init = (root) => {
    if (root.dataset.heroReady) return;
    root.dataset.heroReady = '1';
    const slides = [...root.querySelectorAll('[data-slide]')];
    const slideLinks = [...root.querySelectorAll('[data-slide-link]')];
    const media = [...root.querySelectorAll('[data-slide-media]')];
    const dots = [...root.querySelectorAll('[data-dot]')];
    const live = root.querySelector('[data-slides]');
    if (slides.length < 2) return;

    const duration = Math.max(1, parseFloat(root.dataset.duration) || 7) * 1000;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    let elapsed = 0;
    let last = null;
    let focused = false;
    let frame = 0;

    const autoplay = () => !motion.matches;
    const paused = () => focused || document.hidden;

    const setProgress = (p) => {
      const dot = dots[current];
      if (dot) dot.style.setProperty('--hero-progress', String(Math.min(1, Math.max(0, p))));
    };

    // Bildwechsel ohne Weiss dazwischen (Pastel #40): altes Bild bleibt 500 ms deckend liegen
    let prevMedia = null;
    let prevTimer = 0;

    const show = (index) => {
      const before = current;
      current = (index + slides.length) % slides.length;
      if (before !== current) {
        const out = media.find((m) => Number(m.dataset.slideMedia) === before);
        if (prevMedia && prevMedia !== out) prevMedia.classList.remove('is-prev');
        window.clearTimeout(prevTimer);
        if (out) {
          out.classList.add('is-prev');
          prevMedia = out;
          prevTimer = window.setTimeout(() => { out.classList.remove('is-prev'); prevMedia = null; }, 500);
        }
      }
      slides.forEach((s, i) => {
        const on = i === current;
        s.classList.toggle('is-active', on);
        s.toggleAttribute('inert', !on);
        if (on) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
      });
      media.forEach((m) => m.classList.toggle('is-active', Number(m.dataset.slideMedia) === current));
      // Klickflaeche der Slide (Pastel #2) folgt der sichtbaren Slide
      slideLinks.forEach((a) => a.classList.toggle('is-active', Number(a.dataset.slideLink) === current));
      dots.forEach((d, i) => {
        const on = i === current;
        d.classList.toggle('home-hero__dot--active', on);
        if (on) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
        d.style.removeProperty('--hero-progress');
      });
      elapsed = 0;
      last = null;
      // ohne Autoplay zeigt der Strich den statischen Figma-Stand (Default in CSS)
      if (autoplay()) setProgress(0);
    };

    const tick = () => {
      frame = 0;
      if (!autoplay()) return;
      const now = Date.now();
      if (paused()) {
        last = null;
      } else {
        if (last !== null) elapsed += Math.max(0, now - last);
        last = now;
        if (elapsed >= duration) show(current + 1);
        else setProgress(elapsed / duration);
      }
      schedule();
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(tick);
    };

    const updateLive = () => {
      if (live) live.setAttribute('aria-live', autoplay() && !paused() ? 'off' : 'polite');
    };
    const onState = () => {
      last = null;
      updateLive();
      schedule();
    };

    root.addEventListener('focusin', (e) => {
      focused = e.target instanceof Element && e.target.matches(':focus-visible');
      onState();
    });
    root.addEventListener('focusout', (e) => {
      if (!root.contains(e.relatedTarget)) { focused = false; onState(); }
    });
    document.addEventListener('visibilitychange', onState);
    motion.addEventListener('change', () => { show(current); onState(); });

    dots.forEach((d, i) => d.addEventListener('click', () => { show(i); onState(); }));

    /*
     * Wischen (Alex, Pastel #1, 22.09. + Nachfass 23.09.): "make the slide move horizontally with the
     * finger. the subline and the headline move with it, the pagination stays in the same place and just
     * changes state to the next active slide."
     * Bewegt werden nur die Textslides (Ueberschrift + Unterzeile). Die Punkte liegen ausserhalb von
     * [data-slides] und bleiben darum stehen; die Hintergrundbilder blenden weiter ueber.
     * Waagerecht/senkrecht wird ab 8px Weg entschieden: senkrechtes Scrollen soll nicht blaettern.
     * Ab einem Drittel der Fensterbreite (mindestens 40px) wird weitergeblaettert, sonst federt die
     * Slide zurueck. Nur Finger/Stift, nicht Maus.
     */
    const track = root.querySelector('[data-slides]');
    let sx = 0, sy = 0, sid = null, axis = null, peek = -1;

    const peekIndex = (dx) => (current + (dx < 0 ? 1 : -1) + slides.length) % slides.length;

    const drawDrag = (dx) => {
      const width = root.clientWidth || 1;
      const next = peekIndex(dx);
      if (next !== peek) {
        if (peek >= 0 && peek !== current) slides[peek].classList.remove('is-peek');
        peek = next;
        if (peek !== current) slides[peek].classList.add('is-peek');
      }
      slides[current].style.transform = 'translateX(' + dx + 'px)';
      if (peek !== current) {
        slides[peek].style.transform = 'translateX(' + (dx + (dx < 0 ? width : -width)) + 'px)';
      }
    };

    const clearDrag = () => {
      slides.forEach((s) => { s.style.transform = ''; s.classList.remove('is-peek'); });
      track.classList.remove('is-dragging', 'is-settling');
      peek = -1;
    };

    const endDrag = (dx) => {
      const width = root.clientWidth || 1;
      const threshold = Math.max(40, width / 3);
      const target = Math.abs(dx) >= threshold ? peekIndex(dx) : current;
      track.classList.remove('is-dragging');
      if (target === current || motion.matches) {
        if (target !== current) { clearDrag(); show(target); onState(); }
        else clearDrag();
        return;
      }
      // Ausfedern: aktuelle Slide ganz raus, neue Slide auf 0 - danach uebernimmt show()
      track.classList.add('is-settling');
      slides[current].style.transform = 'translateX(' + (dx < 0 ? -width : width) + 'px)';
      slides[target].style.transform = 'translateX(0px)';
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        clearDrag();
        show(target);
        onState();
      };
      slides[target].addEventListener('transitionend', finish, { once: true });
      window.setTimeout(finish, 320);
    };

    root.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse') return;
      sid = e.pointerId; sx = e.clientX; sy = e.clientY; axis = null;
    }, { passive: true });
    root.addEventListener('pointermove', (e) => {
      if (sid === null || e.pointerId !== sid) return;
      const dx = e.clientX - sx, dy = e.clientY - sy;
      if (axis === null) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (axis === 'x') track.classList.add('is-dragging');
      }
      if (axis !== 'x') return;
      drawDrag(dx);
    }, { passive: true });
    root.addEventListener('pointerup', (e) => {
      if (sid === null || e.pointerId !== sid) return;
      const dx = e.clientX - sx;
      sid = null;
      if (axis !== 'x') return;
      axis = null;
      endDrag(dx);
    }, { passive: true });
    root.addEventListener('pointercancel', () => { sid = null; axis = null; clearDrag(); }, { passive: true });

    show(0);
    onState();
  };

  const run = () => document.querySelectorAll('[data-home-hero]').forEach(init);
  run();
  document.addEventListener('shopify:section:load', run);
})();
